'use client';

import { envHasDevFlagsEnabled } from '../util/envHasDevFlagsEnabled';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect, useState } from 'react';

/**
 * This hook is used to check if the LaunchDarkly client is ready.
 * It uses the useLDClient hook from launchdarkly-react-client-sdk.
 * It returns true if the client is ready, false otherwise.
 *
 * @returns {boolean} - True if the client is ready, false otherwise.
 */
export function useIsLDClientReady(): boolean {
  const [isClientReady, setIsClientReady] = useState(false);
  const client = useLDClient();
  useEffect(() => {
    const waitForClient = async () => {
      if (client !== undefined && !isClientReady) {
        await client.waitForInitialization();
        setIsClientReady(true);
      }
    };
    if (envHasDevFlagsEnabled()) {
      waitForClient();
    }
  }, [client, isClientReady]);

  return isClientReady;
}
